module.exports = __webpack_public_path__ + "img/202309_03.33894f37.jpg";